function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.9577 25.782C34.0259 27.6567 32.6851 30 30.5516 30H2.78043C0.642873 30 -0.691733 27.653 0.374355 25.782L14.2601 1.40537C15.3288 -0.470156 18.0055 -0.466758 19.0723 1.40537L32.9577 25.782ZM16.6662 20.7422C15.196 20.7422 14.0042 21.9489 14.0042 23.4375C14.0042 24.9261 15.196 26.1328 16.6662 26.1328C18.1364 26.1328 19.3282 24.9261 19.3282 23.4375C19.3282 21.9489 18.1364 20.7422 16.6662 20.7422ZM14.1388 11.0539L14.5681 19.0227C14.5882 19.3956 14.8927 19.6875 15.2615 19.6875H18.0709C18.4397 19.6875 18.7442 19.3956 18.7643 19.0227L19.1936 11.0539C19.2153 10.6512 18.8985 10.3125 18.5002 10.3125H14.8322C14.4338 10.3125 14.1171 10.6512 14.1388 11.0539Z",
  fill: "#4D00B4"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.939d8f78.svg";
export { ForwardRef as ReactComponent };